'use strict';
require('./VendorAdmin.scss');

const React = require('react'),
  {t} = require('services/i18nextWrapper'),
    { map } = require('lodash/collection'),
    CustomDialog = require('components/Commons/Dialog/CustomDialogHolder'),
    AdminScaffolding = require('components/Commons/AdminScaffolding/AdminScaffolding'),
    Loading = require('components/Commons/Loading/Loading'),
    /* NumberUtils = require('utils/NumberUtils'), */
    AdminScaffoldingTable = require('components/Commons/AdminScaffolding/AdminScaffoldingTable/AdminScaffoldingTable'),
    AdminScaffoldingContextHolder = require('components/Commons/AdminScaffolding/AdminScaffoldingContextHolder'),
    FormGroupTextfield = require('components/Commons/BasicForm/FormGroupTextfield/FormGroupTextfield'),
    FormGroupButton = require('components/Commons/BasicForm/FormGroupButton/FormGroupButton'),
    Authentication = require('services/Security').Authentication,
    InventoryStore = require('stores/InventoryStore'),
    get = require('lodash/object').get,
    Stamps = require('components/Commons/Stamps/Stamps'),
    Stamp = require('components/Commons/Stamps/Stamp/Stamp'),
    { Navigation } = require('react-router'),
    ga = require('react-ga');

const CONTACT_ICONS = {
    ['PHONE']: 'phone',
    ['EMAIL']: 'email'
};

let VendorAdmin = React.createClass({displayName: "VendorAdmin",
    mixins: [Authentication, AdminScaffoldingContextHolder, Navigation],

    getInitialState() {
        return {
            selectedVendor: null
        };
    },

    componentDidMount() {
        this.fetchVendor();
        ga.pageview('/vendors-admin');
    },

    fetchVendor() {
        const self = this;
        InventoryStore.fetchVendor(function(vendors) {
            self.setState({
                vendors
            });
        });
    },

    _goToAddress() {
        this.transitionTo(
            '/vendors/:vendorId/addresses',
            {
                vendorId: get(this.state, 'selectedItem.id')
            },
            {
                companyName: get(this.state, 'selectedItem.companyName')
            }
        );
    },

    _goToContacts() {
        this.transitionTo(
            '/vendors/:vendorId/contacts',
            {
                vendorId: get(this.state, 'selectedItem.id')
            },
            {
                companyName: get(this.state, 'selectedItem.companyName')
            }
        );
    },

    _goToItems() {
        this.transitionTo(
            '/vendors/:vendorId/items',
            {
                vendorId: get(this.state, 'selectedItem.id')
            },
            {
                companyName: get(this.state, 'selectedItem.companyName')
            }
        );
    },

    _onDeleteVendor(vendorId, onSuccess, onFailure) {
        CustomDialog.showWarningConfirmation(
            t('warning'),
            t('vendor_admin_confirm_delete_supplier'),
            () => {
                InventoryStore.deleteVendor(vendorId, onSuccess, onFailure);
            }
        );
    },

    _onChangeVendor(vendor, onSuccess, onFailure) {
        InventoryStore.changeVendor(vendor, onSuccess, onFailure);
    },

    _onAddVendor(vendor, onSuccess, onFailure) {
        InventoryStore.addVendor(vendor, onSuccess, onFailure);
    },

    _onRowSelection(
        item,
        itemIndex,
        lastRowScrollPosition,
        headerActiveFilters
    ) {
        this.setState(
            {
                selectedItem: item,
                headerActiveFilters
            },
            () => {
                // stay the position of the scroll after row select when
                // the offset is outside of initial viewport page.
                this.getDOMNode().querySelector(
                    '.mui-body-table'
                ).scrollTop = lastRowScrollPosition;
            }
        );
    },

    _onCancel() {
        this.setState({
            selectedItem: null
        });
    },

    _getBreadcrumbLinks() {
        return [
            {
                displayName: t('dashboard_sidebar_suppliers')
            }
        ];
    },

    _onEnterPress() {
        if (this.onEnterKeyDown) {
            this.onEnterKeyDown();
        }
    },

    _addEnterKeyDown(onEnterKeyDown) {
        this.onEnterKeyDown = onEnterKeyDown;
    },

    _getStampsIcons(contacts) {
        return (
            React.createElement(Stamps, null, 
                map(contacts, contact => {
                    return (
                        React.createElement("span", {className: "bp-vendor-admin__contact"}, 
                            React.createElement(Stamp, {
                                icon: CONTACT_ICONS[get(contact, 'type')], 
                                classNameIcon: "material-icons", 
                                className: "bp-vendor-admin__contact-icon"}
                            ), 
                            React.createElement("div", {className: "bp-vendor-admin__contact-label ellipsis"}, 
                                get(contact, 'contactInfo')
                            )
                        )
                    );
                })
            )
        );
    },

    render() {
        let { vendors, selectedItem } = this.state;
        if (!vendors) {
            return React.createElement(Loading, null);
        } else {
    
            const messages = {
                changeSuccessMessage: t('vendor_admin_change_success_message'),
                changeFailureMessage: t('vendor_admin_change_failure_message'),
                deleteSuccessMessage: t('vendor_admin_delete_success_message'),
                addSuccessMessage: t('vendor_admin_add_success_message'),
                addFailureMessage: t('vendor_admin_add_failure_message')
            };
    
            const additionalButtons = [
                {
                    type: 'CHANGE',
                    permission: 'SHOW',
                    el: (
                        React.createElement(FormGroupButton, {
                            label: t('vendor_admin_label_set_address'), 
                            icon: "subdirectory_arrow_right", 
                            type: "icon", 
                            onClick: this._goToAddress.bind(this)}
                        )
                    )
                },
                {
                    type: 'CHANGE',
                    permission: 'SHOW',
                    el: (
                        React.createElement(FormGroupButton, {
                            label: t('vendor_admin_address_set_contacts'), 
                            icon: "subdirectory_arrow_right", 
                            type: "icon", 
                            onClick: this._goToContacts.bind(this)}
                        )
                    )
                },
                {
                    type: 'CHANGE',
                    permission: 'SHOW',
                    el: (
                        React.createElement(FormGroupButton, {
                            label: t('vendor_admin_set_items'), 
                            icon: "subdirectory_arrow_right", 
                            type: "icon", 
                            onClick: this._goToItems.bind(this)}
                        )
                    )
                }
            ];

            let contextHolder = this.getContextHolderInstance();

            const formFieldsEl = [
                React.createElement(FormGroupTextfield, {
                    operationsHolder: contextHolder, 
                    readerAttribute: "companyName", 
                    isRequired: true, 
                    name: t('vendor_admin_label_company_name'), 
                    value: selectedItem, 
                    label: t('vendor_admin_label_company_name'), 
                    onEnter: this._onEnterPress}
                ),
                React.createElement(FormGroupTextfield, {
                    operationsHolder: contextHolder, 
                    readerAttribute: "dueDate", 
                    isRequired: true, 
                    name: t('vendor_admin_label_due_date'), 
                    value: selectedItem, 
                    label: t('vendor_admin_label_due_date'), 
                    onEnter: this._onEnterPress}
                ),
                React.createElement(FormGroupTextfield, {
                    operationsHolder: contextHolder, 
                    readerAttribute: "termsDate", 
                    isRequired: true, 
                    name: t('vendor_admin_label_terms'), 
                    value: selectedItem, 
                    label: t('vendor_admin_label_terms'), 
                    /* additionalValidation={inputValue =>
                        NumberUtils.isNumber(inputValue)
                            ? ''
                            : t('vendor_admin_must_be_number')} */
                    onEnter: this._onEnterPress}
                )
            ];

            return (
                React.createElement("div", {className: "brewhouse-view"}, 
                    React.createElement(AdminScaffolding, {
                        title: t('vendor_admin_title_suppliers'), 
                        moduleName: "ADMIN_VENDOR", 
                        onAddText: t('vendor_admin_label_associate'), 
                        onDeleteText: t('vendor_admin_label_disassociate'), 
                        messages: messages, 
                        contextHolder: contextHolder, 
                        value: selectedItem, 
                        fetchItems: this.fetchVendor, 
                        headerFields: formFieldsEl, 
                        onAdd: this._onAddVendor, 
                        onChange: this._onChangeVendor, 
                        onCancel: this._onCancel, 
                        onDelete: this._onDeleteVendor, 
                        additionalButtons: additionalButtons, 
                        addEnterKeyDown: this._addEnterKeyDown, 
                        breadcrumb: this._getBreadcrumbLinks()
                    }, 

                        React.createElement(AdminScaffoldingTable, {
                            headerActiveFilters: this.state.headerActiveFilters, 
                            onRowSelection: this._onRowSelection, 
                            value: selectedItem, 
                            sortByColumn: ['companyName'], 
                            filteredColumns: [
                                'companyName',
                                'contacts',
                                'dueDate',
                                'termsDate'
                            ], 
                            columnNames: [
                                t('vendor_admin_label_company_name'),
                                t('vendor_admin_column_name_contacts'),
                                t('vendor_admin_label_due_date'),
                                t('vendor_admin_label_terms')
                            ], 
                            displayAttributes: [
                                'companyName',
                                {
                                    name: 'contacts',
                                    getHTML: this._getStampsIcons
                                },
                                'dueDate',
                                'termsDate'
                            ]
                        }, 
                            vendors
                        )
                    )
                )
            );
        }
    }
});

module.exports = VendorAdmin;



/** WEBPACK FOOTER **
 ** ./src/views/VendorAdmin/VendorAdmin.js
 **/